import axios from 'axios';

const API_URL = '/api';

// Axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Tüm isteklere token ekleme
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;

// Instagram API fonksiyonları
export const getInstagramReels = async (limit = 8) => {
    try {
        const response = await api.get(`/instagram/reels?limit=${limit}`);
        return response.data;
    } catch (error) {
        console.error('Instagram reels fetch error:', error);
        return {
            success: false,
            error: 'Instagram reels alınamadı',
            data: []
        };
    }
};

export const getInstagramAccount = async () => {
    try {
        const response = await api.get('/instagram/account');
        return response.data;
    } catch (error) {
        console.error('Instagram account fetch error:', error);
        return {
            success: false,
            error: 'Instagram hesap bilgileri alınamadı',
            data: null
        };
    }
};